import React from 'react'

export default function About() {
   return (
      <main className='about _container'>
         About
      </main>
   )
}
